import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type CustomFieldsPreloaderService from '@/services/preloaders/customFieldsPreloaderService'
import type { IMainServerSub, IServerEventName } from '@/services/transport/serverEvents'

@injectable()
export default class UserCustomFieldsEventResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.CustomFieldsPreloaderService)
    protected readonly customFieldsPreloaderService: CustomFieldsPreloaderService,
    @inject(SERVICE_TYPES.ServerSubscriptionService)
    protected readonly serverSubscriptionService: IMainServerSub,
  ) {}

  private clearCacheEvent: IServerEventName = 'customFieldsCacheClear'

  private reloadCustomFields = async () => {
    this.customFieldsPreloaderService.markAsNotPreloaded()
    await this.customFieldsPreloaderService.preload()
  }

  public async resolve() {
    this.serverSubscriptionService.subscribe(this.clearCacheEvent, this.reloadCustomFields)
  }

  public async unresolve() {
    this.serverSubscriptionService.unsubscribeAll(this.clearCacheEvent)
  }
}
